// extracted by mini-css-extract-plugin
export default {"container":"SpinWheelContainer_container__oFaaD","spinWheel":"SpinWheelContainer_spinWheel__Tt+bw"};